var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"menu"},_vm._l((_vm.menu),function(item,index){return _c('router-link',{key:index,staticClass:"menu__item",attrs:{"to":item.link,"tag":"li"}},[_c('a',{staticClass:"menu__link"},[_vm._v(_vm._s(item.name))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }